module.exports = __webpack_public_path__ + "img/audio-bg-fill2.97dc7bea.png";